import styled from "styled-components"
import { useContext } from "react"
import { useT, useLocale } from "react-polyglot-hooks"
import { CarContext } from "scenes/CarScene/CarContext"
import Typography from "../../styled/Typography"

const Wrapper = styled.div`
  margin-top: 25px;
`

const Text = styled(Typography)`
  font-weight: 400;
  display: block;
`

export default function Disclaimer() {
  const t = useT()
  const locale = useLocale()
  const { car } = useContext(CarContext)

  return (
    <Wrapper>
      <Text variant="small" color="gray">
        {t("car_data.disclaimer.1")}
      </Text>
      <Text variant="small" color="gray">
        {t("car_data.disclaimer.2")}
      </Text>
      {locale === "it" && (
        <Text variant="small" color="gray">
          {t("car_data.disclaimer.3")}
        </Text>
      )}
      {locale === "es" && car.hasReplacementTyres && (
        <Text variant="small" color="gray">
          {t("car_data.disclaimer.footnote")}
        </Text>
      )}
    </Wrapper>
  )
}
